import { instance } from "libs/api";

import { ApiRoutesRecommendation } from "../../constants";
import { ProductAttributes } from "../../recommendation.types";

export const requestRevertProductAttributes = async ({
  id,
  fields
}: {
  id: string;
  fields?: string[];
}): Promise<ProductAttributes | null> => {
  return await instance.post(
    `${ApiRoutesRecommendation.Enrichment}/${encodeURIComponent(id)}/revert`,
    { fields }
  );
};
